import { TimelineMax, Power0 } from "gsap";

export default class Animations {

    constructor() {
        this.curtain = '.curtain';
    }

    pageIn(){
        let that = this;

        var transition = new TimelineMax({
            onComplete: function () {
                $(that.curtain).removeClass('active');
            }
        });

        transition
            .set( ( that.curtain ), { yPercent: 0 })
            .set( ( that.curtain + ' svg'), { autoAlpha: 1 })
            .to( ( that.curtain + ' svg'), 0.5, { autoAlpha: 0, ease: Power3.easeIn }, 0)
            .to( ( that.curtain ), 0.5, { yPercent: 100, ease: Power3.easeIn }, 0);

    }

    pageOut(){

        let that = this;
        $(that.curtain).addClass('active');
        var transition = new TimelineMax();

        transition
            .set( ( that.curtain ), { yPercent: -100, autoAlpha: 1 })
            .set( ( that.curtain + ' svg'), { autoAlpha: 0 })
            .to((that.curtain), 0.5, { autoAlpha: 1, yPercent: 0, ease: Power3.easeOut, onComplete: function() {  window.scrollTo({  top: 0, left: 0, behavior: 'auto'  }); }}, 0)
            .to((that.curtain + ' svg'), 0.5, { autoAlpha: 1, ease: Power3.easeOut }, 0)

    }

    projectsIn()
    {
        let masterTimeline = new TimelineMax();
        masterTimeline
            .fromTo('.hero.static .hero--title span', 0.2, { yPercent: 100 }, { yPercent: 0 }, 0.3).delay(0.5);
    }

    projectIn()
    {
        let masterTimeline = new TimelineMax({
            onStart: function () {
                this.set(window, { scrollTo: 0 })
            }
        });

        masterTimeline
            .fromTo('.hero.static', 0.3, { height: '100vh' }, { height: '90vh' }, 0.3)
            .fromTo('.hero.static .hero__slide-image', 0.3,{ scale: 1.3 }, { scale: 1, ease: Power0.easeOut }, 0.3)
            .fromTo('.hero.static .hero__slide-video', 0.3, { scale: 1.3 }, { scale: 1, ease: Power0.easeOut  }, 0.3)
            .from('.hero.static .client-name', 0.3, { xPercent: -100, autoAlpha: 0 })
            .from('.hero.static .slides__supporting', 0.3, { yPercent: -100, autoAlpha: 0 }, 0.9)
            .staggerFromTo('.hero.static .slides__title span em', 0.2, { yPercent: 100 }, { yPercent: 0 }, 0.1, 0.9);

        if ( $(window).scrollTop() > 0 ){
            masterTimeline
                .delay(0.75);
        }
    }

    pageHeaderIn()
    {
        let masterTimeline = new TimelineMax();
        masterTimeline
            .staggerFromTo('.image__header--inner .slides__title span em', 0.2, { yPercent: 100 }, { yPercent: 0 }, 0.1, 0.3)
    }

    pageOutNoCurtain( store, page ) {
        let that = this;
        let masterTimeline = new TimelineMax();
        masterTimeline
            .to('canvas', 0.5, { scale: 1.3 })
            .to('.bar', 0.5, { height: 0, onComplete: function(){
                store.dispatch('updatePage', page );
            }}, 0)
    }

    pageReset( fromMenu = false ) {

        if( fromMenu ) {
            this.menuOut();
        } else {
            this.pageIn();
        }

        setTimeout(() => {
            if ($('html').hasClass('activemenu')) {
                $('html').removeClass('activemenu');
                $('.header__menu-trigger').removeClass('active');
                $('.menu__wrapper, .burger').removeClass('active');
                window.scrollTo({  top: 0, left: 0, behavior: 'auto'  });
            }
        }, 400);
    }

    menuIn() {
        $('.burger').addClass('active');
        $('.header__menu-trigger').addClass('active');
        $('html').addClass('activemenu');
        $('.wrap').addClass('menued');

        let menuHeight = $(window).outerHeight(true) + 100;
        let menuAnim = new TimelineMax();

        let fullTime = 1;
        let quarterTime = (fullTime / 4);
        let thirdTime = (fullTime / 3);
        let halfTime = (fullTime / 2);
        let tinyTime = (fullTime / 10);
        let start = 0;

        menuAnim
            .set($('.menu li'), { autoAlpha: 1 })
            .set($('.menu li span'), { yPercent: -100 })
            .set($('.menu__wrapper .social li'), { autoAlpha: 0, yPercent: -100 })
            .set($('.menu__wrapper .contact--menu li a'), { autoAlpha: 0, xPercent: -100, yPercent: 0 })
            .set($('.menu__wrapper .contact--menu .email span.line'), { width: '0%' })
            .fromTo('.menu__wrapper', halfTime, { height: '0', paddingTop: 0 }, { paddingTop: '25vh' , height: menuHeight })
            .staggerTo($('.menu li span'), thirdTime, { yPercent: 0, ease: Power3.easeOut }, tinyTime, quarterTime )
            .staggerTo('.menu__wrapper .social li', thirdTime, {autoAlpha: 1, yPercent: 0}, tinyTime, quarterTime )
            .to('.menu__wrapper .contact--menu .email span.line', thirdTime, { width: '97%' }, thirdTime )
            .to('.menu__wrapper .contact--menu li a', thirdTime, { autoAlpha: 1, xPercent: 0 }, halfTime )
            .to('.header__menu-trigger', thirdTime, { width: 50 }, quarterTime);

        // .fromTo('.menu__wrapper', halfTime, { height: '0', paddingTop: 0 }, { paddingTop: '25vh' , height: menuHeight, ease: CustomEase.create("custom", "M0,0 C0.612,0.118 0.638,1 1,1") })

    }

    menuOut( pageTransition ) {
        let that = this;

        if( pageTransition ) {
            that.pageOut();
        }

        var menuAnim = new TimelineMax({
            onComplete: function () {
                $('.burger').removeClass('active');
                $('.header__menu-trigger').removeClass('active');
                $('html').removeClass('activemenu');
                $('.menu__wrapper').css({ 'height' : 0, 'top' : 0 });
            }
        });

        $('.wrap').removeClass('menued');

        let fullTime = 1;
        let quarterTime = (fullTime / 4);
        let thirdTime = (fullTime / 3);
        let halfTime = (fullTime / 2);
        let tinyTime = (fullTime / 10);
        let start = 0;
        let triggerWidth = 50;
        if( $(window).width() > 767)
        {
            triggerWidth = 100;
        }

        menuAnim
            .staggerTo($('.menu li span'), thirdTime, { yPercent: 100, ease: Power3.easeOut }, tinyTime, tinyTime)
            .staggerTo('.menu__wrapper .social li', thirdTime, { autoAlpha: 0, yPercent: 100 }, tinyTime, tinyTime)
            .to('.menu__wrapper .contact--menu .email span.line', thirdTime, { width: '0%' }, tinyTime)
            .to('.menu__wrapper .contact--menu li a', thirdTime, { autoAlpha: 0, yPercent: 100 }, thirdTime)
            .to(('.menu__wrapper'), halfTime, { top: '100%', paddingTop: 0 }, halfTime)
            .to('.header__menu-trigger', tinyTime, { width: triggerWidth }, halfTime)

    }

    exploreOut() {
        let masterTimeline  = new TimelineMax();
        masterTimeline
            .to('.slides__nav', 0.3, { autoAlpha: 0, xPercent: 100 })
            .to('.slides__title span em', 0.3, { yPercent: 100 }, 0)
            .to('.client-name', 0.3, { autoAlpha: 0, xPercent: 100 }, 0)
            .to('.slides__supporting', 0.3, { autoAlpha: 0, xPercent: -100 }, 0)
            .to('.trigger--explore', 0.3, { x: -50, autoAlpha: 0 }, 0.1);
    }

    slideCounter(sel, duration)
    {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline
            .to( obj, (duration / 3), { autoAlpha: 0, xPercent: '100%' } )
            .to( obj, (duration / 3), { xPercent: '-100%' })
            .to( obj, (duration / 3), { autoAlpha: 1, xPercent: '0%'});
        return timeline;
    }

    mainTextIn()
    {
        let obj = $('.swiper-slide-active .slides__title');
        let span = obj.find('span');
        let em = span.find('em');
        let timeline = new TimelineMax({ paused: true });
        timeline
            .set(span, {overflow: 'hidden', display: 'block'})
            .set(em, { yPercent: '100%' })
            .staggerTo(em, 0.3, { yPercent: '0%' }, 0.1);
        return timeline;
    }

    downAndIn( sel , duration )
    {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline.from(obj, duration, { autoAlpha: 0, yPercent: '-100%' });
        return timeline;
    }

    upAndIn(sel, duration) {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline.from(obj, duration, { autoAlpha: 0, yPercent: '100%' });
        return timeline;
    }

    topBar( sel, duration )
    {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline
            .to(obj, duration, { yPercent: '-100%' })
            .to(obj, duration, { yPercent: '0%' });
        return timeline;
    }

    bottomBar(sel, duration) {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline
            .to(obj, duration, { yPercent: '100%' })
            .to(obj, duration, { yPercent: '0%' });
        return timeline;
    }

    scaleSlide(sel, duration) {
        let obj = $(sel);
        let timeline = new TimelineMax({ paused: true });
        timeline.to( obj, (duration/2), { scale: 1.75 } ).to(obj, (duration/2), {scale: 1});
        return timeline;
    }

    slideIn()
    {
        this.slideCounter('.swiper-slide-active .slides__num--count', 0.6).play();
        this.slideCounter('.swiper-slide-active .client-name', 0.6).play();
        this.upAndIn('.swiper-slide-active .trigger', 0.6).play();
        this.mainTextIn().play();
        this.downAndIn('.swiper-slide-active .slides__supporting', 0.4).play();
    }

    slideOut()
    {
        this.slideCounter('.swiper-slide-active .slides__num--count', 0.6).play();
        this.slideCounter('.swiper-slide-active .client-name', 0.6).play();
        this.upAndIn('.swiper-slide-active .trigger', 0.6).progress(1).reverse();
        this.mainTextIn().progress(1).reverse();
        this.downAndIn('.swiper-slide-active .slides__supporting', 0.4).progress(1).reverse();
    }

    slideInOut()
    {

        this.topBar('.bar--top', 0.3).play();
        this.bottomBar('.bar--bot', 0.3).play();

        this.scaleSlide('.swiper-slide video',0.6).play();

        this.slideCounter('.swiper-slide-active .slides__num--count', 0.6).play()
        this.slideCounter('.swiper-slide-active .slides__num--count', 0.6).reverse();

        this.slideCounter('.swiper-slide-active .client-name', 0.6).play();
        this.slideCounter('.swiper-slide-active .client-name', 0.6).reverse();

        this.upAndIn('.swiper-slide-active .trigger', 0.6).progress(1).reverse()
        this.upAndIn('.swiper-slide-active .trigger', 0.6).progress(0).play();

        this.mainTextIn().progress(1).reverse();
        this.mainTextIn().progress(0).play();

        this.downAndIn('.swiper-slide-active .slides__supporting', 0.4).progress(1).reverse();
        this.downAndIn('.swiper-slide-active .slides__supporting', 0.4).progress(0).play();

    }


    followMe( target ) {
        $.attractHover(
            target,
            {
                proximity: 60,
                magnetism: 3
            }
        );
    }
}